import noop from 'lodash/noop';
import semaphore from './semaphore';

const HIDE_LOADER_TIMEOUT = 100;

export default function withLoaderFactory(showLoader = noop, hideLoader = noop) {
    return async function withLoader<T>(callback: () => T) {
        const newTaskCounter = semaphore();
        newTaskCounter.onTake(() => showLoader());
        newTaskCounter.onLeave(() => hideLoader());

        return Promise.resolve()
            .then(() => {
                newTaskCounter.take();
                return callback();
            })
            .then((data) => {
                delayedLeave(newTaskCounter);
                return data;
            })
            .catch((err) => {
                delayedLeave(newTaskCounter);
                throw err;
            });
    };

    function delayedLeave(taskCounter: ReturnType<typeof semaphore>) {
        window.setTimeout(() => taskCounter.leave(), HIDE_LOADER_TIMEOUT);
    }
}
